import * as React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import PropTypes from "prop-types";
import expensePreview from "../../assets/client_expenses_preview.png";
import Grid from "@material-ui/core/Grid";
import { appAction } from "../../actions/app.action";
import { API } from "../../utilities/api.config";
import { portfolioAction } from "../../actions/portfolio.action";
import Button from "@material-ui/core/Button";
import SectionHeader from "../../components/UI/SectionHeader";
import SectionCaption from "../../components/UI/SectionCaption";
import { householdAction } from "../../actions/household.action";
import Axios from "axios";
import { downloadBlob } from "../../utilities/download-blob";

const styles = (theme) => ({
  feedCard: {
    marginBottom: 20,
  },
  contentWrapper: {
    width: "100%",
    display: `flex`,
    flexDirection: "column",
    paddingBottom: theme.wbiComponent.educationComponent.height + 10,
  },
  contentCaption: {
    marginBottom: 10,
  },
  thumbnail: {
    height: 240,
    textAlign: "center",
    marginBottom: 20,
    "& img": {
      height: "100%",
    },
  },
  bold: {
    fontWeight: 500,
    marginBottom: 10,
  },
});

class Downloads extends React.Component {
  state = {
    clientExpensesDownloading: false,
  };
  componentDidMount() {
    this.props.dispatch(portfolioAction.clearCurrentPortfolio());
    this.props.dispatch(householdAction.clearCurrentHousehold());
    this.props.dispatch(appAction.setPortfolioNav());
    this.props.dispatch(appAction.toggleMainNav(false));
    this.props.dispatch(appAction.setEducationNav(true));
    window.scrollTo(0, 0);
  }
  downloadDocument = () => {
    this.setState({ clientExpensesDownloading: true }, () => {
      Axios
        .get(API.DOWNLOAD_CLIENT_EXPENSE, { responseType: 'blob' })
        .then((response) => response.data)
        .then((blob) => downloadBlob(blob, 'Cy Client Expense Worksheet.pdf'))
        .then(() => this.setState({ clientExpensesDownloading: false }));
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.contentWrapper}>
        <div>
          <SectionHeader text={"Downloads"} />
          <Grid container spacing={3}>
            <Grid item xs={6} className={classes.feedCard}>
              <SectionCaption className={classes.bold}>
                Client Expenses Worksheet
              </SectionCaption>

              <div className={classes.thumbnail}>
                <img src={expensePreview} alt={"expenses preview"} />
              </div>

              <Button
                color="primary"
                size="small"
                variant="outlined"
                style={{ float: "right" }}
                onClick={this.downloadDocument}
              >
                Download
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

Downloads.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    app: state.app,
    user: state.user,
  };
};
export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps)(Downloads)
);



// WEBPACK FOOTER //
// ./src/containers/Downloads/index.jsx